import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const dashboardViewRoute: InvariantJiraRoute = {
	name: 'dashboard-view',
	path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
	query: ['maximized?'],
	exact: true,
};
